import React, { Fragment } from 'react'

import ControlBar from './ControlBar'
import LogsListLoader from './_load/LogsListLoader'
import LogsTable from './table/LogsTable'

const PageContent = () => {
  return (
    <Fragment>
      <ControlBar />

      <LogsListLoader>
        <LogsTable />
      </LogsListLoader>
    </Fragment>
  )
}

export default PageContent
